import { jsx as _jsx } from "react/jsx-runtime";
import ErrorBoundary from '../ErrorBoundary';
import { IncaContextProviderRR } from './IncaContextProviderRR';
import { ScopedDesignedForm } from './ScopedDesignedForm';
export const ScopedRegisterRecord = (props)=>{
    const { registerRecordId, createStore, createValidator, children, components } = props;
    return(// @ts-ignore oklart
    /*#__PURE__*/ _jsx(ErrorBoundary, {
        children: /*#__PURE__*/ _jsx(IncaContextProviderRR, {
            registerRecordId: registerRecordId,
            components: components,
            children: /*#__PURE__*/ _jsx(ScopedDesignedForm, {
                createStore: createStore,
                createValidator: createValidator,
                children: (data)=>children(data)
            })
        })
    }));
};
